import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import { AppModule } from './app/app.module';
import { licenseKey } from './devextreme-license';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

config({ licenseKey });

platformBrowser()
    .bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
    })

    .catch((err) => console.error(err));
